export let VIDEO_CONSTRAINS = {
  verylow: {
    width: { ideal: 160 },
    aspectRatio: 1.334,
  },
  low: {
    width: { ideal: 240 },
    aspectRatio: 1.334,
  },
  medium: {
    width: { ideal: 320 },
    aspectRatio: 1.334,
  },
  high: {
    width: { ideal: 480 },
    aspectRatio: 1.334,
  },
  veryhigh: {
    width: { ideal: 640 },
    aspectRatio: 1.334,
  },
  ultra: {
    width: { ideal: 1280 },
    aspectRatio: 1.334,
  },
};